module.exports = new __parcel__URL__("bfg.9943b7ba.png").toString();